module.exports = __webpack_public_path__ + "static/media/heathrow-logo.e8b40737.svg";